import 'edge/quoteandbind/common/models/Submission';
import PASubmissionDataExtension from 'edge/quoteandbind/pa/models/PASubmissionDataExtension';
import BOPSubmissionDataExtender from 'edge/quoteandbind/bop/models/BOPSubmissionDataExtender';
import WCSubmissionDataExtension from '/edge/quoteandbind/wc/models/WCSubmissionDataExtension';

export default {
    mixinLobDataExtensions: function mixinLobDataExtensions(submission) {
        if (submission && submission.baseData && submission.baseData.productCode === 'PersonalAuto') {
            submission.lobData = submission.lobData || {};
            submission.lobData.personalAuto = new PASubmissionDataExtension(submission);
        }
        if (submission && submission.baseData && submission.baseData.productCode === 'BusinessOwners') {
            BOPSubmissionDataExtender.extend(submission);
        }
        if (submission && submission.baseData && submission.baseData.productCode === 'WorkersComp') {
            submission.lobData = submission.lobData || {};
            submission.lobData.workersComp = new WCSubmissionDataExtension(submission);
            console.log('PolicyLineExtensionConfiguration submission.lobData.workersComp:');
            console.log(submission.lobData.workersComp);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/PolicyLineExtensionConfiguration.js
// module id = 2222
// module chunks = 0